import BasePage from "@Scripts/Pages/BasePage";

export default class SiteStructurePage extends BasePage {
    public static async init() {
        await super.init();

        this.setAnimationMetballs();
        this.setAnimationAirOff();
        this.setAnimationCardPrototypes();
        this.setAnimationLeaves();
        this.setAnimationMoldPreparation();
        this.setAnimationPlateOptimization();
    }

    private static setAnimationMetballs() {
        var metballs = document.getElementsByClassName("metballs");

        if (metballs) {
            gsap.to(".metballs .layer-01", {
                transform: "translate(5vh, 10vh) rotate(0)",
                scrollTrigger: {
                    trigger: ".trigger",
                    start: "top 130%",
                    end: "top -20%",
                    scrub: true,
                }
            });

            gsap.to(".metballs .layer-02", {
                transform: "translate(4vh, -15vh)",
                scrollTrigger: {
                    trigger: ".trigger",
                    start: "top 130%",
                    end: "top -20%",
                    scrub: true,
                }
            });

            gsap.to(".metballs .layer-03", {
                transform: "translate(4vh, 5vh) rotate(0)",
                scrollTrigger: {
                    trigger: ".trigger",
                    start: "top 130%",
                    end: "top -20%",
                    scrub: true,
                }
            });

            gsap.to(".metballs .layer-04", {
                transform: "translate(0, -12vh)",
                scrollTrigger: {
                    trigger: ".trigger",
                    start: "top 130%",
                    end: "top -20%",
                    scrub: true,
                }
            });

            gsap.to(".metballs .layer-05", {
                transform: "translate(2.5vh, -5vh)",
                scrollTrigger: {
                    trigger: ".trigger",
                    start: "top 130%",
                    end: "top -20%",
                    scrub: true,
                }
            });

            gsap.to(".metballs .layer-06", {
                transform: "translate(-8vh, -4vh)",
                scrollTrigger: {
                    trigger: ".trigger",
                    start: "top 130%",
                    end: "top -20%",
                    scrub: true,
                }
            });
        }
    }

    private static setAnimationAirOff() {
        var imageAiroff = document.getElementsByClassName("image-airoff");

        if (imageAiroff) {
            gsap.to(".image-airoff .layer-01", {
                transform: "translate(0, 0)",
                scrollTrigger: {
                    trigger: ".image-airoff",
                    start: "top 130%",
                    end: "top -20%",
                    scrub: true,
                }
            });

            gsap.to(".image-airoff .layer-02", {
                transform: "translate(0, 0)",
                scrollTrigger: {
                    trigger: ".image-airoff",
                    start: "top 130%",
                    end: "top -20%",
                    scrub: true,
                }
            });

            gsap.to(".image-airoff .layer-03", {
                transform: "translate(0, 0)",
                scrollTrigger: {
                    trigger: ".image-airoff",
                    start: "top 130%",
                    end: "top -20%",
                    scrub: true,
                }
            });

            gsap.to(".image-airoff .layer-04", {
                transform: "translate(0, 0)",
                scrollTrigger: {
                    trigger: ".image-airoff",
                    start: "top 130%",
                    end: "top -20%",
                    scrub: true,
                }
            });

            gsap.to(".image-airoff .layer-05", {
                transform: "translate(0, 0) rotate(0)",
                scrollTrigger: {
                    trigger: ".image-airoff",
                    start: "top 130%",
                    end: "top -20%",
                    scrub: true,
                }
            });
        }
    }

    private static setAnimationCardPrototypes() {
        var cardPrototypes = document.getElementsByClassName("card-prototypes");

        if (cardPrototypes) {
            gsap.to(".card-prototypes .layer-01", {
                transform: "translate(5vh, 10vh) rotate(0)",
                scrollTrigger: {
                    trigger: ".card-prototypes",
                    start: "top 130%",
                    end: "top -150%",
                    scrub: true,
                }
            });

            gsap.to(".card-prototypes .layer-02", {
                transform: "translate(4vh, -15vh)",
                scrollTrigger: {
                    trigger: ".card-prototypes",
                    start: "top 130%",
                    end: "top -150%",
                    scrub: true,
                }
            });

            gsap.to(".card-prototypes .layer-03", {
                transform: "translate(4vh, 5vh) rotate(0)",
                scrollTrigger: {
                    trigger: ".card-prototypes",
                    start: "top 130%",
                    end: "top -150%",
                    scrub: true,
                }
            });

            gsap.to(".card-prototypes .layer-04", {
                transform: "translate(0, -12vh)",
                scrollTrigger: {
                    trigger: ".card-prototypes",
                    start: "top 130%",
                    end: "top -150%",
                    scrub: true,
                }
            });

            gsap.to(".card-prototypes .layer-05", {
                transform: "translate(2.5vh, -5vh)",
                scrollTrigger: {
                    trigger: ".card-prototypes",
                    start: "top 130%",
                    end: "top -150%",
                    scrub: true,
                }
            });

            gsap.to(".card-prototypes .layer-06", {
                transform: "translate(-8vh, -4vh)",
                scrollTrigger: {
                    trigger: ".card-prototypes",
                    start: "top 130%",
                    end: "top -150%",
                    scrub: true,
                }
            });
        }
    }

    private static setAnimationLeaves() {
        var Leaves = document.getElementsByClassName("image-leaves");

        if (Leaves) {
            gsap.to(".image-leaves .layer-01", {
                transform: "translate(0, 0) rotate(0)",
                scrollTrigger: {
                    trigger: ".image-leaves",
                    start: "top 130%",
                    end: "top -100%",
                    scrub: true,
                }
            });

            gsap.to(".image-leaves .layer-02", {
                transform: "translate(0, 0)",
                scrollTrigger: {
                    trigger: ".image-leaves",
                    start: "top 130%",
                    end: "top -100%",
                    scrub: true,
                }
            });

            gsap.to(".image-leaves .layer-03", {
                transform: "translate(0, 0) rotate(0)",
                scrollTrigger: {
                    trigger: ".image-leaves",
                    start: "top 130%",
                    end: "top -100%",
                    scrub: true,
                }
            });
        }
    }

    private static setAnimationMoldPreparation() {
        var moldPreparation = document.getElementsByClassName("mold-preparation");

        if (moldPreparation) {
            gsap.to(".mold-preparation .layer02", {
                opacity: 1,
                scrollTrigger: {
                    trigger: ".mold-preparation .layer02",
                    start: "top 40%",
                    end: "top 25%",
                    scrub: true,
                }
            });
        }
    }

    private static setAnimationPlateOptimization() {
        var plateOptimization = document.getElementsByClassName("plate-optimization");

        if (plateOptimization) {
            gsap.to(".plate-optimization .layer-02", {
                opacity: 1,
                scrollTrigger: {
                    trigger: ".plate-optimization .layer-02",
                    start: "top 40%",
                    end: "top 25%",
                    scrub: true,
                }
            });
        }
    }
}